import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	warningsButtonLabel: {
		id: 'portfolio-3-portfolio.app-simple-plans.top.title-bar.warnings.warnings-button-label',
		defaultMessage: 'Warnings',
		description: 'It is the label of the "Warnings" button in the toolbar of the header.',
	},
});
